import buttonShapes from "@insite/mobius/Button/buttonShapes";
import buttonTypes from "@insite/mobius/Button/buttonTypes";
import hoverAnimations from "@insite/mobius/Button/hoverAnimations";
import { COLORS } from "@tKgpco/theme/design";
import { transitionHoverStyles } from "@tKgpco/theme/mixins/transition";
import { css } from "styled-components";

export const buttonDisabledStyles = (buttonType: string) => {
    switch (buttonType) {
        case "solid":
            return css`
                &:disabled {
                    color: ${COLORS.disabled.dark};
                    background-color: ${COLORS.disabled.light};
                    border-color: ${COLORS.disabled.light};
                }
            `;
        case "outline":
            return css`
                &:disabled {
                    color: ${COLORS.disabled.dark};
                    background-color: ${COLORS.background.base};
                    border-color: ${COLORS.disabled.light};
                }
            `;
        default:
            break;
    }
};

export const buttonBaseStyles = (buttonType: string) => {
    const baseStyle = css`
        height: auto;
        min-width: 125px;
        min-height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 13px 24px;
        ${transitionHoverStyles()}
    `;

    const tertiaryStyle = css`
        border-radius: 22px;
    `;

    switch (buttonType) {
        case "solid":
            return css`
                ${baseStyle}
                ${buttonDisabledStyles(buttonType)}
            `;
        case "outline":
            return css`
                ${baseStyle}
                ${buttonDisabledStyles(buttonType)}
            `;
        case "tertiary":
            return css`
                ${baseStyle}
                ${buttonDisabledStyles(buttonType)}
                ${tertiaryStyle}
            `;
        default:
            return null;
    }
};

export interface StoreThemeButtonProps {
    variant?: string;
    type?: string;
    shape?: string;
    animation?: string;
}

export const themeButtonStyles = ({ variant = "primary", type, shape, animation }: StoreThemeButtonProps) => {
    return css`
        ${({ theme }) => {
            const _buttonVariantProps = theme.button[variant];

            if (_buttonVariantProps) {
                const _buttonTypes: any = buttonTypes;
                const _buttonShapes: any = buttonShapes;
                const _hoverAnimations: any = hoverAnimations;

                const _buttonTypeFunction =
                    (type ? _buttonTypes[type] : _buttonTypes[_buttonVariantProps.buttonType]) || null;
                const _buttonShapeFunction =
                    (shape ? _buttonShapes[shape] : _buttonShapes[_buttonVariantProps.shape]) || null;
                const _hoverAnimationFunction =
                    (animation ? _hoverAnimations[animation] : _hoverAnimations[_buttonVariantProps.hoverAnimation]) ||
                    null;

                const buttonProps = {
                    ..._buttonVariantProps,
                    _color: _buttonVariantProps.color,
                    _sizeVariant: _buttonVariantProps.sizeVariant,
                    _size: _buttonVariantProps.size,
                    _shape: _buttonVariantProps.shape,
                    theme,
                };

                return css`
                    ${_buttonTypeFunction ? _buttonTypeFunction(buttonProps) : null}
                    ${_buttonShapeFunction ? _buttonShapeFunction(buttonProps) : null}
                    ${_hoverAnimationFunction ? _hoverAnimationFunction(buttonProps) : null}
                `;
            }

            return null;
        }}
    `;
};
